

export const ButtonsOrder = ({updateOrder}) => {
    return <div className="h-20">
    <button
      type="submit"
      onClick={() => updateOrder("finish")}
      className="flex-grow w-1/2 h-20 bg-indigo-600 px-3 py-2 text-4xl font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
    >
      ✓
    </button>
    <button
      type="button"
      className="flex-grow h-20 w-1/2 bg-white px-3 py-2 text-3xl font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
      onClick={() => updateOrder("cancel")}
    >
      ❌
    </button>
    {/*<button
      type="button"
      className="flex-grow h-20 w-1/3 bg-white px-3 py-2 text-3xl font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
      onClick={() => updateOrder("pending")}
    >
      ?
    </button>*/}
  </div>
}